const SLIDE_WIDTH = 300;
const SLIDE_OFFSET = 10;

export { SLIDE_WIDTH, SLIDE_OFFSET };
